import React from 'react';
import { ParentRoomProvider, useParentRoom } from './ParentRoomProvider';
import RoomsSelection from './RoomsSelection';
import RelatedRoomsSelection from './RelatedRoomsSelection';
import { useDebouncedRoomsData } from '../../services/queries/rooms';
import FetchDataWrapper from '../../../../components/FetchDataWrapper';
import RoomsCountSetter from './RoomsCountSetter';

const RoomsList = ({ children }) => {
  const { data, isFetching, refetch } = useDebouncedRoomsData();

  return (
    <FetchDataWrapper
      data={data}
      isFetching={isFetching}
      refetch={refetch}
      errMsg="Не удалось получить список помещений"
    >
      <RoomsCountSetter data={data}>
        <ParentRoomProvider>
          <Content data={data}>{children}</Content>
        </ParentRoomProvider>
      </RoomsCountSetter>
    </FetchDataWrapper>
  );
};

export default RoomsList;

function Content({ data, children }) {
  const parentRoom = useParentRoom();

  return parentRoom ? (
    <RelatedRoomsSelection parentRoom={parentRoom} />
  ) : (
    <div className="colContentWrap">
      <RoomsSelection data={data}>{children}</RoomsSelection>
    </div>
  );
}
